<div class="float-right">
  <div *ngIf="loading; else acceptRejectButtons">
    <p>Loading...</p>
  </div>
  <ng-template #acceptRejectButtons>
    <button (click)="reject()" class="btn btn-danger controls">Reject</button>
    <button (click)="accept()" class="btn btn-success controls">Accept</button>
  </ng-template>
</div>
